import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBodyPattern } from "../../Redux/Action/getBodyPattern";
import { getSleevePattern } from "../../Redux/Action/getSleevePattern";
import { getCapPattern } from "../../Redux/Action/getCapPattern";
import { Button, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import fourthSvgData from "../../Data/Svg3";
import { getColor } from "../../Redux/Action/getColor";
import axios from "axios";
import { postCustomShirt } from "../../Redux/Action/postCustomShirt";
import { clearState } from "../../Redux/Reducer/postCustomShirtReducer";
import Loaders from "../Loader/Loaders";
import { Modal } from "react-bootstrap";
import BuyNow from '../../Pages/BuyNow';

const ShirtThreeDisplay = ({
  capColors,
  capMarkingColor,
  sleeveColors,
  sleevesMarkingColor,
  bodyColors,
  bodyMarkingColors,
  bodyId,
  capId,
  sleevesID,
}) => {
  const dispatch = useDispatch();
  const { success, error, data, loading } = useSelector(
    (state) => state.postCustomShirt
  );
  const [modalShow, setModalShow] = useState(false);

  const bodyData = useSelector((state) => state.getBodyPattern.data);
  const sleeveData = useSelector((state) => state.getSleevePattern.data);
  const capData = useSelector((state) => state.getCapPattern.data);
  const svgRef = useRef(null);
  const { id } = useParams();
  const [waterMarkImage, setWaterMarkImage] = useState();
  const [show, setShow] = useState(true);

  const waterMark = {
    fillRule: "evenodd",
    opacity: 0.15,
  };

  useEffect(() => {
    const element = document.getElementById("eeellle");
    setWaterMarkImage(element);
  }, [waterMarkImage]);

  useEffect(() => {
    const ShirtType = id;
    dispatch(getBodyPattern(ShirtType));
    dispatch(getSleevePattern(ShirtType));
    dispatch(getCapPattern(ShirtType));
    dispatch(getColor());
    localStorage.removeItem("imageData");
  }, [dispatch]);

  const downloadImage = async () => {
    const svg = svgRef.current;
    const watermarkElement = svg.querySelector("#eeellle");
    watermarkElement.classList.add("wpMark");

    if (watermarkElement) {
      watermarkElement.remove();
    }

    const svgData = new XMLSerializer().serializeToString(svg);

    if (watermarkElement) {
      svg.appendChild(watermarkElement);
    }

    const formats = ["svg", "png", "jpg"];

    for (const format of formats) {
      const scaleFactor = 3;
      const canvas = document.createElement("canvas");
      const svgSize = svg.getBoundingClientRect();
      canvas.width = svgSize.width * scaleFactor;
      canvas.height = svgSize.height * scaleFactor;
      const ctx = canvas.getContext("2d");
      const img = new Image();

      await new Promise((resolve, reject) => {
        img.onload = () => {
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          let dataURL;

          switch (format) {
            case "svg":
              dataURL = "data:image/svg+xml;base64," + btoa(svgData);
              localStorage.setItem("svgImage", svgData);
              break;
            case "png":
              dataURL = canvas.toDataURL("image/png");
              localStorage.setItem("pngImage", dataURL);
              break;
            case "jpg":
              dataURL = canvas.toDataURL("image/jpeg");
              localStorage.setItem("jpgImage", dataURL);
              break;
            default:
              break;
          }

          resolve();
        };

        img.onerror = (error) => {
          console.error("Image load error: ", error);
          reject(error);
        };

        img.src = "data:image/svg+xml;base64," + btoa(svgData);
      });
    }
  };

  const downloadImageOnlyPng = () => {
    const svg = svgRef.current;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const svgSize = svg.getBoundingClientRect();
    canvas.width = svgSize.width;
    canvas.height = svgSize.height;
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL("image/png");
      localStorage.setItem("image", dataURL);
    };

    img.onerror = (error) => {
      console.error("Image load error: ", error);
    };

    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  const handleClick = async () => {
    const svg = svgRef.current;
    await downloadImageOnlyPng();
    await downloadImage();
    const waterMark = localStorage.getItem("image");
    const withoutWaterMarked = localStorage.getItem("pngImage");

    const formData = new FormData();
    formData.append("markedImage", dataURLtoBlob(waterMark));
    formData.append("image", dataURLtoBlob(withoutWaterMarked));
    formData.append("svgPath", localStorage.getItem("svgImage"));

    try {
      await dispatch(postCustomShirt(formData));
    } catch (error) {
      console.error("API error:", error);
    }
  };

  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  useEffect(() => {
    const observerCallback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          mutation.removedNodes.forEach((node) => {
            // Check if the removed node has the 'wpMark' class
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              !node.classList.contains("wpMark")
            ) {
              if (node.id === "eeellle") {
                setShow(false);
              }
            }
          });
        }
      }
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (success) {
      message.success(success);
      dispatch(clearState());
      localStorage.removeItem("image");
      localStorage.removeItem("pngImage");
      localStorage.removeItem("svgImage");
      localStorage.removeItem("jpgImage");
      setModalShow(true);
    }
    if (error) {
      message.error(error);
      dispatch(clearState());
      localStorage.removeItem("image");
      localStorage.removeItem("pngImage");
      localStorage.removeItem("svgImage");
      localStorage.removeItem("jpgImage");
    }
  }, [success, error]);

  const handleClosee = () => {
    setModalShow(false);
  };

  return (
    <div className="imageeeSvg">
      {show && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 650 1010"
          width="100%"
          height="auto"
          ref={svgRef}
          className="shirtsvg"
          style={{ background: "#FFF" }}
        >
          {fourthSvgData?.svg.elements?.map((item) => (
            <g data-name="Layer 1">
              {item.id == "body-button-color" && (
                <g id="body-button-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              {item.id == "left-body-border" && (
                <g id="left-body-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              {item.id == "left-body-color" && (
                <g id="left-body-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              {item.id == "right-body-border" && (
                <g id="left-body-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              {item.id == "right-body-color" && (
                <g id="right-body-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}

              {item.id == "right-sleeve-border" && (
                <g id="right-sleeve-border">
                  <path d={item.d} />
                </g>
              )}

              {item.id == "right-sleeve-color" && (
                <g id="right-sleeve-color">
                  <path style={sleeveColors} d={item.d} />
                </g>
              )}

              {item.id == "left-collar-color" && (
                <g id="left-collar-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              {item.id == "left-collar-border" && (
                <g id="left-body-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              {item.id == "right-collar-border" && (
                <g id="left-body-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              {item.id == "right-collar-color" && (
                <g id="right-collar-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}

              {item.id == "main-collar-color" && (
                <g id="main-collar-color">
                  <path style={bodyColors} d={item.d} />
                </g>
              )}
              <g>
                {item.id == "cap-front" && (
                  <g id="cap-front">
                    <path style={capColors} d={item.d} />
                  </g>
                )}

                {item.id == "cap-upper" && (
                  <g id="cap-upper">
                    <path style={capColors} d={item.d} />
                  </g>
                )}
              </g>

              {item.id == "abc" && (
                <g id="abc">
                  <path d={item.d} />
                </g>
              )}

              {item.id == "button-1" && (
                <g id="button-1">
                  <circle cx={item.cx} cy={item.cy} r={item.r} />
                </g>
              )}

              {item.id == "button-2" && (
                <g id="button-2">
                  <circle cx={item.cx} cy={item.cy} r={item.r} />
                </g>
              )}
              {item.id == "button-3" && (
                <g id="button-3">
                  <circle cx={item.cx} cy={item.cy} r={item.r} />
                </g>
              )}

              {item.id == "button-4" && (
                <g id="button-4">
                  <circle cx={item.cx} cy={item.cy} r={item.r} />
                </g>
              )}

              {item.id == "button-5" && (
                <g id="button-5">
                  <circle cx={item.cx} cy={item.cy} r={item.r} />
                </g>
              )}
            </g>
          ))}

          {bodyData?.items?.map(
            (item, index) =>
              bodyId === item._id && (
                <svg
                  key={index}
                  className="bboddy"
                  style={{ strokeWidth: "3" }}
                  dangerouslySetInnerHTML={{
                    __html: `${item.SvgPath.replace(
                      /^<div>|<\/div>$/g,
                      ""
                    )}<style>.bboddy path { fill: ${
                      bodyMarkingColors.fill
                    }; } .bboddy polygon { fill: ${
                      bodyMarkingColors.fill
                    }; } .bboddy rect { fill: ${
                      bodyMarkingColors.fill
                    }; } .bboddy ellipse { fill: ${
                      bodyMarkingColors.fill
                    }; } .bboddy circle { fill: ${
                      bodyMarkingColors.fill
                    }; } .bboddy polyline { fill: ${
                      bodyMarkingColors.fill
                    }; } .bboddy line { fill: ${
                      bodyMarkingColors.fill
                    }; }</style>`,
                  }}
                />
              )
          )}

          {fourthSvgData?.svg.elements?.map((item) => (
            <g>
              {item.id == "left-sleeve-border" && (
                <g id="left-sleeve-border">
                  <path d={item.d} />
                </g>
              )}

              {item.id == "left-sleeve-color" && (
                <g id="left-sleeve-color">
                  <path style={sleeveColors} d={item.d} />
                </g>
              )}
            </g>
          ))}

          {sleeveData?.items?.map(
            (item, index) =>
              sleevesID === item._id && (
                <svg
                  key={index}
                  className="ssleevvee"
                  style={{ strokeWidth: "3" }}
                  dangerouslySetInnerHTML={{
                    __html: `${item.SvgPath.replace(
                      /^<div>|<\/div>$/g,
                      ""
                    )}<style>.ssleevvee path { fill: ${
                      sleevesMarkingColor.fill
                    }; } .ssleevvee circle { fill: ${
                      sleevesMarkingColor.fill
                    }; } .ssleevvee polygon{fill: ${
                      sleevesMarkingColor.fill
                    }; } .ssleevvee rect {fill: ${
                      sleevesMarkingColor.fill
                    }; } .ssleevvee ellipse {fill: ${
                      sleevesMarkingColor.fill
                    }; } .ssleevvee polyline {fill: ${
                      sleevesMarkingColor.fill
                    }; } .ssleevvee line {fill: ${
                      sleevesMarkingColor.fill
                    }; }</style>`,
                  }}
                />
              )
          )}

          <g id="eeellle">
            {fourthSvgData?.svg.elements?.map((item) => (
              <g>
                {item.id == "watermark" && (
                  <g id="watermark">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}

                {item.id == "watermark-1" && (
                  <g id="watermark-1">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}

                {item.id == "watermark-2" && (
                  <g id="watermark-2">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}

                {item.id == "watermark-3" && (
                  <g id="watermark-3">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}

                {item.id == "watermark-4" && (
                  <g id="watermark-4">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}

                {item.id == "watermark-5" && (
                  <g id="watermark-5">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}

                {item.id == "watermark-6" && (
                  <g id="watermark-6">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}

                {item.id == "watermark-7" && (
                  <g id="watermark-7">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}
                {item.id == "watermark-8" && (
                  <g id="watermark-8">
                    <path style={waterMark} d={item.d} id="eeellle" />
                  </g>
                )}
              </g>
            ))}
          </g>

          {capData?.items?.map(
            (item, index) =>
              capId === item._id && (
                <svg
                  key={index}
                  className="ccaapp"
                  style={{ strokeWidth: "3" }}
                  dangerouslySetInnerHTML={{
                    __html: `${item.SvgPath.replace(
                      /^<div>|<\/div>$/g,
                      ""
                    )}<style>.ccaapp path { fill: ${
                      capMarkingColor.fill
                    }; } .ccaapp circle { fill: ${
                      capMarkingColor.fill
                    }; } .ccaapp rect { fill: ${
                      capMarkingColor.fill
                    }; } .ccaapp polygon { fill: ${
                      capMarkingColor.fill
                    }; } .ccaapp ellipse { fill: ${
                      capMarkingColor.fill
                    }; } .ccaapp line { fill: ${
                      capMarkingColor.fill
                    }; } .ccaapp polyline { fill: ${
                      capMarkingColor.fill
                    }; }</style>`,
                  }}
                />
              )
          )}
        </svg>
      )}

      <div className="Pricee">
        <p className="big">$2.00</p>
      </div>

      <div className="button">
        <Button className="buynow" onClick={handleClick} disabled={loading}>
          {loading ? <Loaders /> : "Check Out"}
        </Button>
      </div>

      <Modal show={modalShow} onHide={handleClosee} className="buyNowModal">
        <Modal.Header closeButton>
          <h2>Check Out</h2>
        </Modal.Header>
        <Modal.Body>
          <BuyNow designData={data} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ShirtThreeDisplay;
